// Match Cards — over/under cards odds table (Phase 3 → M2 wave 9). Identical to
// Match Goals but for the cards market dataset + the `cm-wrapper` class; thin
// wrapper over the shared <MarketTable>. The cards dataset now comes from app-api
// via `useWidgetData` (was the `getCardsMarketData` legacyData getter); bookmaker
// + scope reshape the fetched payload client-side (no refetch).

import { shapeMarketTable } from "@bento/shared";
import { useWidgetData } from "../../data/useWidgetData.js";
import { useFixtureKey } from "../../data/useFixtureKey.js";
import MarketTable from "./MarketTable.js";
import WidgetSkeleton from "./WidgetSkeleton.js";
import WidgetError from "./WidgetError.js";

export interface MatchCardsProps {
  fixture: string;
  /** Bookmaker toggle; defaults to "Pinnacle". */
  bookmaker?: string | null;
  /** Market scope toggle ("Match" | team abbr); defaults to "Match". */
  scope?: string | null;
}

export default function MatchCards({
  fixture,
  bookmaker,
  scope,
}: MatchCardsProps) {
  const { data, isPending, isError, refetch } = useWidgetData(
    "match-cards",
    useFixtureKey(fixture)
  );
  if (isPending) return <WidgetSkeleton />;
  if (isError) return <WidgetError onRetry={refetch} />;

  const rows =
    shapeMarketTable(
      data ?? {},
      fixture || "Arsenal v Everton",
      scope || "Match",
      bookmaker || "Pinnacle"
    ) ?? [];
  return <MarketTable wrapperClass="cm-wrapper" rows={rows} />;
}
